import { render, staticRenderFns } from "./AdOptimization.vue?vue&type=template&id=8f3efede&scoped=true"
import script from "./AdOptimization.vue?vue&type=script&lang=js"
export * from "./AdOptimization.vue?vue&type=script&lang=js"
import style0 from "./AdOptimization.vue?vue&type=style&index=0&id=8f3efede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3efede",
  null
  
)

export default component.exports